// extracted by mini-css-extract-plugin
export default {"box":"Box_box__gGxrD","box_title":"Box_box_title__XOrlM","box_desc":"Box_box_desc__aZw38","backgroundContent":"Box_backgroundContent__g+RNE","box_image":"Box_box_image__4hGtD"};